import type { Pool } from '../../shared/types';

type PoolPredictionMatchFilters = {
  limit: number;
  isDemo?: boolean;
};

export function getPoolPredictionsMatchFilters(pool: Pool | null | undefined): PoolPredictionMatchFilters {
  if (typeof pool?.isDemo === 'boolean') {
    return {
      limit: 100,
      isDemo: pool.isDemo,
    };
  }

  return {
    limit: 100,
  };
}
